import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gorda-route-integrity" }
const _hoisted_2 = { class: "card mb-2 gorda-route-integrity__filter-card" }
const _hoisted_3 = { class: "gorda-route-integrity__filter-header" }
const _hoisted_4 = { class: "gorda-route-integrity__filter-title" }
const _hoisted_5 = { class: "gorda-route-integrity__filter-heading" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row align-items-end" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = {
  class: "gorda-route-integrity__label",
  for: "route-integrity-from"
}
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = {
  class: "gorda-route-integrity__label",
  for: "route-integrity-to"
}
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = {
  class: "btn gorda-route-integrity__btn-filter me-2",
  type: "submit",
  name: "submit"
}
const _hoisted_18 = {
  class: "gorda-route-integrity__helper",
  role: "note"
}
const _hoisted_19 = { class: "card gorda-route-integrity__table-card" }
const _hoisted_20 = { class: "gorda-table-header" }
const _hoisted_21 = { class: "d-flex align-items-center gap-2" }
const _hoisted_22 = { class: "gorda-table-header-title mb-0" }
const _hoisted_23 = { class: "gorda-table-header-count" }
const _hoisted_24 = {
  key: 0,
  class: "gorda-table-loading-indicator"
}
const _hoisted_25 = { class: "text-secondary text-xs" }
const _hoisted_26 = { class: "table-responsive" }
const _hoisted_27 = { class: "table table-sm table-borderless align-items-center mb-0" }
const _hoisted_28 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2" }
const _hoisted_29 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2 text-center" }
const _hoisted_30 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2 text-center" }
const _hoisted_31 = ["title"]
const _hoisted_32 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2 text-center" }
const _hoisted_33 = ["title"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "ps-2" }
const _hoisted_36 = { class: "ps-2 text-center" }
const _hoisted_37 = { class: "ps-2 text-center" }
const _hoisted_38 = { class: "ps-2 text-center" }
const _hoisted_39 = {
  key: 0,
  class: "text-center py-4 text-secondary text-sm"
}
const _hoisted_40 = {
  key: 1,
  class: "text-center py-4 gorda-route-integrity__empty"
}
const _hoisted_41 = {
  key: 0,
  class: "card mt-2 gorda-route-integrity__drilldown-card"
}
const _hoisted_42 = { class: "gorda-table-header" }
const _hoisted_43 = { class: "d-flex align-items-center gap-2" }
const _hoisted_44 = { class: "gorda-table-header-title mb-0" }
const _hoisted_45 = {
  key: 0,
  class: "text-center py-4 text-secondary text-sm"
}

import { Field, Form } from 'vee-validate'
import { date, object } from 'yup'
import { nextTick, onBeforeMount, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { Modal, Tooltip } from 'bootstrap'
import ServiceRepository from '@/repositories/ServiceRepository'
import DateHelper from '@/helpers/DateHelper'
import { useDriversStore } from '@/services/stores/DriversStore'
import { useRouteIntegrityStore } from '@/services/stores/RouteIntegrityStore'
import { RouteIntegrityMetric } from '@/types/RouteIntegrityMetric'
import { Pagination } from '@/types/Pagination'
import { ServiceCursor } from '@/types/ServiceCursor'
import ToastService from '@/services/ToastService'
import Service from '@/models/Service'
import { ServiceList } from '@/models/ServiceList'
import ServicesTable from '@/components/services/ServicesTable.vue'
import ShowServiceModal from '@/components/services/ShowServiceModal.vue'
import { Tables } from '@/constants/Tables'


export default /*@__PURE__*/_defineComponent({
  __name: 'RouteIntegrityReport',
  setup(__props) {

const { t } = useI18n()
const { findById } = useDriversStore()

const { getReport } = useRouteIntegrityStore()
const { rows, loading, filter } = storeToRefs(useRouteIntegrityStore())

const schema = object().shape({
  from: date().required(),
  to: date().required(),
})

const selectedDriverId = ref<string | null>(null)

// Component-scoped drill-down state (design.md Decision 3): this list/pagination
// is fetched directly through ServiceRepository.getHistoryPage and never touches
// ServiceStore's shared history/pagination/filter/cursor state.
const drillDownServices = ref<ServiceList[]>([])
const drillDownPagination = ref<Pagination>({
  currentPage: 1,
  perPage: 20,
  totalCount: 0,
  cursor: { id: '', created: 0 },
})
const drillDownLoading = ref(false)
const selectedService = ref<ServiceList | null>(null)

async function loadReport(): Promise<void> {
  selectedDriverId.value = null
  resetDrillDown()
  await getReport()
}

function driverName(driverId: string): string {
  return findById(driverId)?.name || driverId
}

function formatRatio(ratio: number): string {
  return `${Math.round(ratio * 100)}%`
}

function ratioBadgeClass(ratio: number): string {
  if (ratio >= 0.5) return 'gorda-route-integrity__ratio-badge--danger'
  if (ratio > 0) return 'gorda-route-integrity__ratio-badge--warning'
  return 'gorda-route-integrity__ratio-badge--success'
}

function resetDrillDown(): void {
  selectedService.value = null
  drillDownServices.value.splice(0)
  drillDownPagination.value.currentPage = 1
  drillDownPagination.value.totalCount = 0
  drillDownPagination.value.cursor = { id: '', created: 0 }
}

// Replicates ServiceStore's setServiceFromFS/attachDriver locally so the
// drill-down never calls ServiceStore.getHistoryServices() or shares its state.
function attachDriverLocal(service: Service): ServiceList {
  const list = Object.assign(new ServiceList(), service)
  list.vehicle = service.vehicle ?? null
  list.driver = list.driver_id ? findById(list.driver_id) ?? null : null
  return list
}

async function loadDrillDown(next = true): Promise<void> {
  if (!selectedDriverId.value) return
  drillDownLoading.value = true
  try {
    const response = await ServiceRepository.getHistoryPage({
      from: DateHelper.getFromDate(filter.value.from),
      to: DateHelper.getToDate(filter.value.to),
      driverId: selectedDriverId.value,
      clientId: null,
      perPage: drillDownPagination.value.perPage,
      cursor: drillDownPagination.value.cursor,
      next,
      routeIntegrity: 'flagged',
    })
    drillDownPagination.value.totalCount = response.totalCount
    drillDownServices.value.splice(0)
    response.services.forEach((service) => {
      drillDownServices.value.push(attachDriverLocal(service))
    })
  } catch (e: any) {
    drillDownServices.value.splice(0)
    await ToastService.toast(ToastService.ERROR, t('common.messages.error'), e?.message)
  } finally {
    drillDownLoading.value = false
  }
}

async function selectDriver(row: RouteIntegrityMetric): Promise<void> {
  selectedDriverId.value = row.driver_id
  selectedService.value = null
  drillDownPagination.value.currentPage = 1
  drillDownPagination.value.cursor = { id: '', created: 0 }
  await loadDrillDown(true)
}

async function paginateDrillDown(page: number, cursor: ServiceCursor, next: boolean): Promise<void> {
  drillDownPagination.value.cursor = cursor
  drillDownPagination.value.currentPage = page
  await loadDrillDown(next)
}

async function show(service: ServiceList): Promise<void> {
  selectedService.value = service
  await nextTick()
  const modalEl = document.getElementById('showServiceModal')
  const modal = new Modal(modalEl ?? 'showServiceModal')
  modal.show()
}

watch(() => drillDownPagination.value.perPage, async () => {
  if (!selectedDriverId.value) return
  drillDownPagination.value.currentPage = 1
  drillDownPagination.value.cursor = { id: '', created: 0 }
  await loadDrillDown(true)
})

onBeforeMount(async () => {
  if (!rows.value.length && !loading.value) {
    await getReport()
  }
})

// Header tooltips are static, so they can be initialized once the component mounts
// (the vendor tooltip auto-init only scans the DOM once, on Dashboard.vue's onMounted).
let headerTooltips: Tooltip[] = []

onMounted(async () => {
  await nextTick()
  headerTooltips = Array.from(document.querySelectorAll('.gorda-route-integrity__header-info'))
    .map((el) => new Tooltip(el))
})

onBeforeUnmount(() => {
  headerTooltips.forEach((tooltip) => tooltip.dispose())
  headerTooltips = []
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "gorda-route-integrity__filter-icon-chip" }, [
            _createElementVNode("em", { class: "fa-solid fa-filter" })
          ], -1)),
          _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.$t('common.filters.title')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Form), {
          onSubmit: loadReport,
          "validation-schema": _unref(schema),
          onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => ($event.preventDefault()), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('common.filters.from')), 1),
                _createVNode(_unref(Field), {
                  name: "from",
                  type: "date",
                  modelValue: _unref(filter).from,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter).from) = $event))
                }, {
                  default: _withCtx(({ field, errorMessage, meta }) => [
                    _withDirectives(_createElementVNode("input", _mergeProps({
                      class: "form-control form-control-sm",
                      type: "date",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      id: "route-integrity-from",
                      "aria-label": "route_integrity_from"
                    }, field, { autocomplete: "none" }), null, 16, _hoisted_10), [
                      [_vModelText, field.value]
                    ]),
                    (errorMessage && meta.dirty)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('common.filters.until')), 1),
                _createVNode(_unref(Field), {
                  name: "to",
                  type: "date",
                  modelValue: _unref(filter).to,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filter).to) = $event))
                }, {
                  default: _withCtx(({ field, errorMessage, meta }) => [
                    _withDirectives(_createElementVNode("input", _mergeProps({
                      class: "form-control form-control-sm",
                      type: "date",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      id: "route-integrity-to",
                      "aria-label": "route_integrity_to"
                    }, field, { autocomplete: "none" }), null, 16, _hoisted_14), [
                      [_vModelText, field.value]
                    ]),
                    (errorMessage && meta.dirty)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.$t('common.actions.filter')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _cache[4] || (_cache[4] = _createElementVNode("em", { class: "fa-solid fa-circle-info gorda-route-integrity__helper-icon" }, null, -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('services.route_integrity.helper_text')), 1)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[5] || (_cache[5] = _createElementVNode("span", {
            class: "gorda-table-header-icon",
            style: {"background":"linear-gradient(310deg, #7928ca, #ff0080)"}
          }, [
            _createElementVNode("em", { class: "fas fa-route" })
          ], -1)),
          _createElementVNode("h6", _hoisted_22, _toDisplayString(_ctx.$t('services.route_integrity.title')), 1),
          _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(rows).length), 1)
        ])
      ]),
      (_unref(loading) && _unref(rows).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _cache[6] || (_cache[6] = _createElementVNode("span", {
              class: "spinner-border spinner-border-sm text-secondary",
              role: "status",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('common.messages.waiting')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("table", _hoisted_27, [
          _cache[7] || (_cache[7] = _createElementVNode("caption", { hidden: "" }, null, -1)),
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('services.route_integrity.fields.driver')), 1),
              _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('services.route_integrity.fields.total_trips')), 1),
              _createElementVNode("th", _hoisted_30, [
                _createTextVNode(_toDisplayString(_ctx.$t('services.route_integrity.fields.flagged_trips')) + " ", 1),
                _createElementVNode("em", {
                  class: "fa-solid fa-circle-info gorda-route-integrity__header-info",
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "top",
                  title: _ctx.$t('services.route_integrity.fields.flagged_trips_tooltip')
                }, null, 8, _hoisted_31)
              ]),
              _createElementVNode("th", _hoisted_32, [
                _createTextVNode(_toDisplayString(_ctx.$t('services.route_integrity.fields.flagged_ratio')) + " ", 1),
                _createElementVNode("em", {
                  class: "fa-solid fa-circle-info gorda-route-integrity__header-info",
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "top",
                  title: _ctx.$t('services.route_integrity.fields.flagged_ratio_tooltip')
                }, null, 8, _hoisted_33)
              ])
            ])
          ]),
          (_unref(rows).length > 0)
            ? (_openBlock(), _createElementBlock("tbody", {
                key: 0,
                class: _normalizeClass(["text-sm", { 'gorda-table-body--loading': _unref(loading) && _unref(rows).length > 0 }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rows), (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.driver_id,
                    class: _normalizeClass(["gorda-route-integrity__row", { 'gorda-route-integrity__row--selected': selectedDriverId.value === row.driver_id }]),
                    onClick: ($event: any) => (selectDriver(row))
                  }, [
                    _createElementVNode("td", _hoisted_35, _toDisplayString(driverName(row.driver_id)), 1),
                    _createElementVNode("td", _hoisted_36, _toDisplayString(row.total_trips), 1),
                    _createElementVNode("td", _hoisted_37, _toDisplayString(row.flagged_trips), 1),
                    _createElementVNode("td", _hoisted_38, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["gorda-route-integrity__ratio-badge", ratioBadgeClass(row.flagged_ratio)])
                      }, _toDisplayString(formatRatio(row.flagged_ratio)), 3)
                    ])
                  ], 10, _hoisted_34))
                }), 128))
              ], 2))
            : _createCommentVNode("", true)
        ]),
        (_unref(loading) && _unref(rows).length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _cache[8] || (_cache[8] = _createElementVNode("em", { class: "fas fa-circle-notch fa-spin me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('common.messages.waiting')), 1)
            ]))
          : (_unref(rows).length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _cache[9] || (_cache[9] = _createElementVNode("em", { class: "fa-solid fa-route fa-lg mb-2 d-block opacity-50" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('services.route_integrity.empty_state')), 1)
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    (selectedDriverId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _cache[10] || (_cache[10] = _createElementVNode("span", {
                class: "gorda-table-header-icon",
                style: {"background":"linear-gradient(310deg, #2152ff, #21d4fd)"}
              }, [
                _createElementVNode("em", { class: "fas fa-list-check" })
              ], -1)),
              _createElementVNode("h6", _hoisted_44, _toDisplayString(_ctx.$t('services.route_integrity.drilldown_title', { driver: driverName(selectedDriverId.value) })), 1)
            ])
          ]),
          (drillDownLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _cache[11] || (_cache[11] = _createElementVNode("em", { class: "fas fa-circle-notch fa-spin me-1" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('common.messages.waiting')), 1)
              ]))
            : (_openBlock(), _createBlock(ServicesTable, {
                key: 1,
                table: _unref(Tables).history,
                services: drillDownServices.value,
                pagination: drillDownPagination.value,
                onPaginate: paginateDrillDown,
                onShowService: show
              }, null, 8, ["table", "services", "pagination"]))
        ]))
      : _createCommentVNode("", true),
    (selectedService.value)
      ? (_openBlock(), _createBlock(ShowServiceModal, {
          key: selectedService.value.id,
          service: selectedService.value
        }, null, 8, ["service"]))
      : _createCommentVNode("", true)
  ]))
}
}

})